require('./searchable-dropdown.js');
require('./nominow-editable.js');
require('./nominow-tableresults.js');
require('./nominow-pagination.js');
require('./nominow-metric.js');
require('./nominow-modal.js');
require('./nominow-customer-edit.js');
require('./nominow-customer-view.js');
require('./nominow-export-file.js');
require('./nominow-table-detail-result.js');
require('./nominow-input-basicselect.js');
require('./nominow-input-select.js');
require('./nominow-input-number.js');
require('./nominow-input-text.js');
require('./nominow-input-textarea.js');
require('./nominow-input-date.js');
require('./nominow-input-checkbox.js');
require('./nominow-input-switch.js');
require('./nominow-input-password.js');
require('./nominow-import-export-modal.js');
require('./nominow-dashboard-chart.js');
require('./nominow-segmentbuilder.js');
require('./nominow-searchable-menulist.js');
require('./nominow-left-navigation.js');
require('./nominow-range-slider.js');
require('./nominow-functionblock.js');

/*CHART Components */
require('./chart/nominow-chart-defaults.js');
require('./chart/nominow-chart-donut.js');
require('./chart/nominow-chart-columns.js');
require('./chart/nominow-chart-bars.js');
require('./chart/nominow-chart-multibars.js');
require('./chart/nominow-chart-lines.js');
require('./chart/nominow-chart-heatmap.js');
require('./chart/nominow-chart-spider.js');
require('./chart/nominow-chart-scatterplot.js');


